import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState, useEffect } from "react";
import { LocationConfirmationMap } from "@/components/location-confirmation-map";
import { useUserLocation } from "@/hooks/useUserLocation";

export const Route = createFileRoute("/app/entregas/confirm-origin")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      type: (search.type as "send" | "receive") || "send",
      destinationLat: search.destinationLat as number,
      destinationLng: search.destinationLng as number,
      destinationAddress: search.destinationAddress as string,
      destinationName: search.destinationName as string | undefined,
      destinationPhone: search.destinationPhone as string | undefined,
      favoritoId: search.favoritoId as string | undefined,
      snapshotId: search.snapshotId as string | undefined,
    };
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const searchParams = Route.useSearch();
  const { coords, address } = useUserLocation();

  const [originLocation, setOriginLocation] = useState(
    coords || { lat: -3.7319, lng: -38.5267 }
  );

  useEffect(() => {
    if (coords) {
      setOriginLocation(coords);
    }
  }, [coords]);

  const handleConfirm = (confirmedLocation: {
    lat: number;
    lng: number;
    address: string;
  }) => {
    // Navigate to checkout with all information
    navigate({
      to: "/app/entregas/checkout",
      search: {
        ...searchParams,
        originLat: confirmedLocation.lat,
        originLng: confirmedLocation.lng,
        originAddress: confirmedLocation.address,
      },
    });
  };

  const handleSearchClick = () => {
    // Open search/autocomplete for origin
    // For now, we'll just go back
    navigate({ to: "/app/entregas/select-destination", search: searchParams });
  };

  return (
    <LocationConfirmationMap
      initialLocation={originLocation}
      onConfirm={handleConfirm}
      onSearchClick={handleSearchClick}
      title="Confirme seu local de partida"
      subtitle={address}
    />
  );
}
